export default "__VITE_ASSET__CqzWgn1Y__"